import {
    GETMULTIPLESELECTFORPARTNER_SUCCESS,
    GETMULTIPLESELECTFORPARTNER_FAILED,
    RESET_GETMULTIPLESELECTFORPARTNER,
    LOADING_GETMULTIPLESELECTFORPARTNER,
    NETWORK_ERROR_GETMULTIPLESELECTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMULTIPLESELECTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMULTIPLESELECTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMULTIPLESELECTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMULTIPLESELECTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMULTIPLESELECTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};